






































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";

class PageLogsRequest extends PageRequest {
  startTime: string;
  endTime: string;
}

@Component({
  components: {},
})
export default class SMSRechargeList extends AbpBase {
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  splitnum: number = 0.01;
  //修改
  edit() {
    this.editModalShow = true;
  }
  //新增
  create() {
    this.createModalShow = true;
  }
  //选择时间
  changeTime(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = val[0];
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  //排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列表
  get list() {
    return this.$store.state.smsrechargelist.list;
  }
  get loading() {
    return this.$store.state.smsrechargelist.loading;
  }
  pageChange(page: number) {
    this.$store.commit("smsrechargelist/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("smsrechargelist/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "smsrechargelist/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.smsrechargelist.pageSize;
  }
  get totalCount() {
    return this.$store.state.smsrechargelist.totalCount;
  }
  get currentPage() {
    return this.$store.state.smsrechargelist.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info[0].displayName,
            },
          },
          info[0].displayName
        );
      },
    },
    {
      align: "left",
      title: this.L("Num"),
      key: "rechargeNum",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("Price"),
      key: "rechargePrice",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("TotalAmmount"),
      key: "rechargeAmmount",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("RechargeTime"),
      key: "rechargeTime",
      width: 150,
      sorttable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.rechargeTime == null
            ? ""
            : Moment(params.row.rechargeTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      align: "left",
      title: this.L("PayType"),
      key: "payTypeId",
      width: 130,
      sorttable: true,
      render: (h: any, params: any) => {
        let id = params.row.payTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      align: "left",
      title: this.L("PayMark"),
      key: "payMark",
      width: 130,
      sorttable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.payMark == 1 ? this.L("Payed") : this.L("NoPay")
        );
      },
    },
    {
      align: "left",
      title: this.L("PackageNum"),
      key: "packageNum",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("RechargeTotalNum"),
      key: "rechargeTotalNum",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("BeforNum"),
      key: "beforNum",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("EndNum"),
      key: "endNum",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("ActionUser"),
      key: "userName",
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                display: params.row.payMark != "1" ? "inline-block" : "none",
              },
              on: {
                click: async () => {
                  let self = this;
                  self.jumppage("paysmsorder", params.row);
                },
              },
            },
            this.L("PayOrder")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                display: params.row.payMark != "1" ? "inline-block" : "none",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "smsrechargelist/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.pagerequest.startTime = Moment()
      .day(-31)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
  }
  //跳转页面
  jumppage(name: string, value: any) {
    this.$router.push({ name: name, params: { value } });
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
